import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@criteria-labs/react';
function ValueBadge({ children }) {
    return (_jsx(Badge, { className: "ml-1", color: "blue", children: children }));
}
export function ParameterEnumValues({ parameter }) {
    if (typeof parameter.schema !== 'object') {
        return null;
    }
    if (parameter.schema.enum === undefined && parameter.schema.default === undefined) {
        return null;
    }
    return (_jsxs("div", { className: "text-xs leading-5 text-zinc-700 dark:text-zinc-300", children: [parameter.schema.enum !== undefined && (_jsxs("p", { children: ["Allowed values:", parameter.schema.enum.map((value, index) => (_jsx(ValueBadge, { children: JSON.stringify(value) }, typeof value === 'string' ? value : `value-${index}`)))] })), parameter.schema.default !== undefined && (_jsxs("p", { children: ["Default value: ", _jsx(ValueBadge, { children: JSON.stringify(parameter.schema.default) })] }))] }));
}
